export const OPTION_TYPES = {
    BASE: 'base',
    ADOBE: 'adobe',
    STORE_LOCATOR: 'storelocator',
    STORE_LOCATOR_RADIUS: 'storelocatorradius',
};
export const DEFAULT_OPTIONS = {
    use: {
        locale: true,
        apiVersion: true,
    },
    customLocale: '',
    apiVersion: 1,
    type: OPTION_TYPES.BASE,
};
//# sourceMappingURL=constants.js.map